module.exports = __webpack_public_path__ + "img/delete-black-24dp.9f4002ec.svg";